import { render, staticRenderFns } from "./ewa.vue?vue&type=template&id=4dda23c4&scoped=true&"
import script from "./ewa.vue?vue&type=script&lang=js&"
export * from "./ewa.vue?vue&type=script&lang=js&"
import style0 from "./ewa.vue?vue&type=style&index=0&id=4dda23c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda23c4",
  null
  
)

export default component.exports